import { useState } from "react";
import { Typography, TextField, Button, Paper } from "@mui/material";
import { useResetCurrentUser } from "../../hooks/useResetCurrentUser"; // Adjust path as needed
import { useReporting } from "../../hooks/useReporting";

const APPCLIENT_ID = import.meta.env.VITE_APP_APPCLIENT_ID;
const BASE_AUTH_URL = import.meta.env.VITE_APP_BASE_AUTH_URL;

export const ResetUserPage = () => {
  const [confirmationText, setConfirmationText] = useState("");
  const { resetUser, isLoading, error } = useResetCurrentUser();
  const { reportClimberReset } = useReporting();

  const CONFIRMATION_PHRASE = "reset me";

  const handleReset = async () => {
    if (confirmationText === CONFIRMATION_PHRASE) {
      sessionStorage.clear();
      try {
        await reportClimberReset();
        await resetUser(CONFIRMATION_PHRASE);
        localStorage.clear();
        const logoutUrl = `${BASE_AUTH_URL}/logout?client_id=${APPCLIENT_ID}&logout_uri=${encodeURI(
          window.location.origin,
        )}/`;
        window.location.href = logoutUrl;
        // onSuccess in the hook will handle reload
      } catch {
        // onError in the hook will log the error
        // Optionally, display a user-friendly error message here
      }
    }
  };

  return (
    <Paper
      sx={{ p: 3, maxWidth: 600, margin: "auto", mt: 4 }}
      label="ResetUserContainer"
    >
      <Typography
        variant="h4"
        component="h1"
        gutterBottom
        color="error"
        label="ResetUserTitle"
      >
        ⚠️ Reset Current User Data ⚠️
      </Typography>
      <Typography variant="body1" paragraph label="ResetUserWarning">
        <strong>Warning:</strong> This action is irreversible and will
        permanently delete all data associated with the currently logged-in
        user. This includes progress, settings, and any other personalized
        information.
      </Typography>
      <Typography variant="body1" paragraph label="ResetUserConfirmationPrompt">
        To proceed, please type the exact phrase
        <strong>{CONFIRMATION_PHRASE}</strong> into the text field below.
      </Typography>
      <TextField
        fullWidth
        variant="outlined"
        label={'Type "' + CONFIRMATION_PHRASE + '" to confirm'}
        value={confirmationText}
        onChange={(e) => setConfirmationText(e.target.value)}
        sx={{ mb: 2 }}
        disabled={isLoading}
        InputProps={{
          "aria-label": "Confirmation Input",
        }}
      />
      <Button
        variant="contained"
        color="error"
        onClick={handleReset}
        disabled={confirmationText !== CONFIRMATION_PHRASE || isLoading}
        fullWidth
        aria-label="Reset User Button"
      >
        {isLoading ? "Resetting..." : "Delete My Data"}
      </Button>
      {error && (
        <Typography color="error" sx={{ mt: 2 }} label="ResetUserError">
          An error occurred: {error.message}
        </Typography>
      )}
    </Paper>
  );
};
